import { RootState } from '../store';
import { createSelector } from '@reduxjs/toolkit';

export const multiSelectSelector = (state: RootState) => state.multiSelect;

export const getListMultiSelectSelector = () =>
  createSelector(multiSelectSelector, (multiSelect) => multiSelect.ids);
